import { Outlet } from 'react-router-dom'
import SimpleNavTabs, { Tab } from '@/common/components/SimpleNavTabs.tsx'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { useSelector } from 'react-redux'
import { RootState } from '@/storage/store.ts'

const Page = () => {
  const { task, error } = useSelector((state: RootState) => state?.tasks)
  const applicantId = task?.scholarship_application_id

  const Tabs: Tab[] = [
    {
      name: 'Task',
      href: AppRoutePaths.tasks.queue,
    },
    {
      name: 'Documents',
      href: applicantId
        ? AppRoutePaths.tasks.documents.replace(
            ':applicantId',
            String(applicantId)
          )
        : AppRoutePaths.tasks.documents,
    },
  ]

  return (
    <div className="flex flex-col">
      {!error && (
        <>
          <SimpleNavTabs tabs={Tabs} />
        </>
      )}
      <Outlet />
    </div>
  )
}
export default Page
